/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import styles from '../../../styles/partials/box-button.scss';

const propTypes = {
    type: PropTypes.oneOf(['button', 'submit']),
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            id: PropTypes.string,
            defaultMessage: PropTypes.string,
        }),
    ]),
    link: PropTypes.string,
    external: PropTypes.bool,
    externalTarget: PropTypes.string,
    red: PropTypes.bool,
    small: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

const defaultProps = {
    type: 'button',
    label: {
        id: 'content.more_info',
        defaultMessage: 'More info',
    },
    link: null,
    external: false,
    externalTarget: '_blank',
    red: false,
    small: false,
    className: null,
    onClick: null,
};

const BoxButton = ({
    type, label, link, external, externalTarget, red, small, className, onClick,
}) => {
    const buttonClassName = classNames({
        [styles.container]: true,
        [styles.red]: red,
        [styles.small]: small,
        [className]: className !== null,
    });
    const buttonProps = {
        className: buttonClassName,
        onClick,
    };
    const buttonLabel = (
        <span className={styles.label}>
            {isString(label) ? label : <FormattedMessage {...label} />}
        </span>
    );
    if (link === null) {
        return (
            <button type={type} {...buttonProps}>
                {buttonLabel}
            </button>
        );
    }
    return external ? (
        <a href={link} target={externalTarget} {...buttonProps} rel="noopener noreferrer">
            {buttonLabel}
        </a>
    ) : (
        <Link to={link} {...buttonProps}>
            {buttonLabel}
        </Link>
    );
};

BoxButton.propTypes = propTypes;
BoxButton.defaultProps = defaultProps;

export default BoxButton;



// WEBPACK FOOTER //
// ./js/components/partials/BoxButton.jsx